import { Injectable, Optional } from "@angular/core";
import { Observable } from "rxjs";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { catchError, tap } from "rxjs/operators";
import {
  OAuthErrorEvent,
  OAuthModuleConfig,
  OAuthResourceServerErrorHandler,
  OAuthService,
  OAuthStorage,
} from "angular-oauth2-oidc";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly oauthStorage: OAuthStorage,
    private readonly oauthService: OAuthService,
    private readonly errorHandler: OAuthResourceServerErrorHandler,
    @Optional() private readonly moduleConfig: OAuthModuleConfig
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq = null;

    if (
      req.headers.get("skip") ||
      req.urlWithParams.indexOf("security.json") > 0 ||
      req.urlWithParams.indexOf("/auth/") > 0
    ) {
      authReq = req.clone({
        headers: req.headers.delete("skip"),
        url: req.url,
      });
      return next.handle(authReq);
    }

    let _url = req.url;

    if (!req.urlWithParams.startsWith('http')) {
      const host = window.location.hostname;
      const port = window.location.port;
      const protocol = window.location.protocol;
      let url = `${protocol}//${host}`;
      if (port) {
        const devPort = "4200";
        const backPort = port === devPort ? "8087" : port;
        url = `${url}:${backPort}`;
      }

      const base = url + "/enquadramento/api";

      _url = base + req.url;
    }

    const token = this.oauthStorage.getItem("access_token");

    authReq = req.clone({
      headers: req.headers.set("Authorization", `Bearer ${token}`),
      url: _url,
    });

    return next.handle(authReq).pipe(
      catchError(err => this.errorHandler.handleError(err))
    );
  }
}
